import { PublicationStatus } from '@/types/questionnaire'
import { Gender, ReceiptSupplier } from '@/types/receipt'
import { QuestionnaireState, RootState } from '@/types/store'
import { Module } from 'vuex'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: QuestionnaireState = {
  isQuestionnaireLoading: false,
  questionnaire: {
    id: -1,
    name: '',
    nameAdmin: '',
    status: PublicationStatus.PUBLIC,
    releaseAt: null,
    releasedAt: null,
    finishAt: null,
    finishedAt: null,
    publicTime: null,
    comment: '',
    description: '',
    isRequiredCheck: false,
    rewardPoint: -1,
    totalLimitDisplay: null,
    totalLimit: null,
    resetLimit: null,
    pobCategoryIds: [],
    targetCodes: [],
    pobCategories: [],
    dailyUpperLimitByJan: -1,
    dailyUpperLimitByChain: -1,
    chainStoreIds: [],
    chianStores: [],
    dailyUpperLimit: -1,
    answerUpperLimit: -1,
    targetSupplier: ReceiptSupplier.WED,
    targetGender: Gender.FEMALE,
    targetUpperLimitAge: -1,
    targetLowerLimitAge: -1,
    targetPrefecture: [],
    targetMarriage: null,
    createdById: -1,
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
    pages: [],
    isAutomatic: true,
    isWelcome: false,
    finishDuration: null,
    memberCodes: [],
    fixedQuestionnaireUrl: null,
    imageUrl: null,
    reachedToLimitAt: null,
    parentId: null,

    total: null,
    totalAnswered: null,
    totalChecked: null,
    totalAdminChecked: null,
    isMustBuy: false, // v2では未実装
    purchaseStartAt: null, // v2では未実装
    purchaseEndAt: null, // v2では未実装
  },
  questionnaires: [],
  completeQuestionnaires: [],
}

export const questionnaire: Module<QuestionnaireState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
